import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { AuthUserContext } from '../session/context';

const MusicPlayerContext = createContext();

const MusicPlayerProvider = ({ children }) => {
      const authContext = useContext(AuthUserContext);
      const authUser = authContext?.authUser || authContext || null;
      const [playlist, setPlaylist] = useState([]);
      const [currentTrack, setCurrentTrack] = useState(null);
      const [selectedPlaylist, setSelectedPlaylist] = useState(
            localStorage.getItem('selectedPlaylist') || null
      );
      const [playlistTracks, setPlaylistTracks] = useState([]);
      const [currentTrackIndex, setCurrentTrackIndex] = useState(
            Number(localStorage.getItem('currentTrackIndex')) || 0
      );
      const [isPlaying, setIsPlaying] = useState(
            localStorage.getItem('isPlaying') === 'true'
      );
      const [isShuffling, setIsShuffling] = useState(
            localStorage.getItem('isShuffling') === 'true'
      );
      const playerRef = useRef(null);

      const addTrackToPlaylist = (track) => {
            setPlaylist([...playlist, track]);
      };

      useEffect(() => {
            if (selectedPlaylist) localStorage.setItem('selectedPlaylist', selectedPlaylist);
      }, [selectedPlaylist]);

      useEffect(() => {
            localStorage.setItem('currentTrackIndex', String(currentTrackIndex));
      }, [currentTrackIndex]);

      useEffect(() => {
            localStorage.setItem('isPlaying', String(isPlaying));
      }, [isPlaying]);

      useEffect(() => {
            localStorage.setItem('isShuffling', String(isShuffling));
      }, [isShuffling]);

      useEffect(() => {
            if (authUser) return;

            try {
                  if (playerRef.current && typeof playerRef.current.pauseVideo === 'function') {
                        playerRef.current.pauseVideo();
                  }
            } catch {
                  // no-op
            }

            setPlaylist([]);
            setCurrentTrack(null);
            setSelectedPlaylist(null);
            setPlaylistTracks([]);
            setCurrentTrackIndex(0);
            setIsPlaying(false);
            setIsShuffling(false);

            try {
                  localStorage.removeItem('selectedPlaylist');
                  localStorage.removeItem('currentTrackIndex');
                  localStorage.removeItem('isPlaying');
                  localStorage.removeItem('isShuffling');
            } catch {
                  // no-op
            }
      }, [authUser, playerRef]);

      return (
            <MusicPlayerContext.Provider
                  value={{
                        playlist,
                        currentTrack,
                        setPlaylist,
                        addTrackToPlaylist,
                        selectedPlaylist,
                        setSelectedPlaylist,
                        playlistTracks,
                        setPlaylistTracks,
                        currentTrackIndex,
                        setCurrentTrackIndex,
                        isPlaying,
                        setIsPlaying,
                        isShuffling,
                        setIsShuffling,
                        playerRef,
                  }}
            >
                  {children}
            </MusicPlayerContext.Provider>
      );
};

export { MusicPlayerContext, MusicPlayerProvider };
